import React from "react";
import axios from "axios";
import Modal from "../../../../shared/components/Modal/Modal";
import { url_295 } from "../../../../custom_utilities/api_services";
import { toastifyMessage } from "../../../../custom_utilities/toastify_config";
import "./DailyGoalModal.css";

function DailyGoalModal({ isOpen, onClose, dailyGoalData, onSaved }) {
  const [selectedGoal, setSelectedGoal] = React.useState(null);
  const [isSaving, setIsSaving] = React.useState(false);

  React.useEffect(() => {
    if (!isOpen) return;
    setSelectedGoal(dailyGoalData?.saved_goal ?? null);
  }, [isOpen, dailyGoalData]);

  if (!dailyGoalData) return null;

  const goalOptions = Array.isArray(dailyGoalData?.goals) ? dailyGoalData.goals : [];

  const handleSave = async () => {
    if (selectedGoal === null || selectedGoal === undefined || isSaving) return;
    try {
      setIsSaving(true);
      const selectedGoalOption = goalOptions.find(
        (goal) => Number(goal?.Goal) === Number(selectedGoal)
      );
      const response = await axios.post(url_295, {
        goal_id: selectedGoalOption?.id,
        saved_goal: selectedGoal,
      });
      if (response?.data?.status === 200) {
        const savedGoalFromApi = response?.data?.data?.saved_goal;
        if (typeof onSaved === "function") {
          await onSaved(savedGoalFromApi ?? selectedGoal);
        }
        onClose();
      }
    } catch (error) {
      toastifyMessage({
        status: error?.response?.data?.status || 500,
        message: error?.response?.data?.message || "Failed to save daily goal",
      });
      // Keep modal open so user can retry save.
      console.error("Failed to save daily goal:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeAboveModal
      stackClassName="daily-goal-modal__dialog-stack"
      width="100%"
      height="auto"
      borderRadius="12px"
      padding="0.625rem 1rem"
      marginTop="0"
    >
      <div className="daily-goal-modal">
        <h3 className="daily-goal-modal__title">Set Daily Goal</h3>
        <p className="daily-goal-modal__subtitle">
          How many questions do you want to solve each day?
        </p>

        <div className="daily-goal-modal__grid">
          {goalOptions.map((goal) => {
            const goalValue = Number(goal?.Goal) || 0;
            const isActive = Number(selectedGoal) === goalValue;
            return (
              <button
                key={goal?.id || goalValue}
                type="button"
                className={`daily-goal-modal__option ${isActive ? "is-active" : ""}`}
                onClick={() => setSelectedGoal(goalValue)}
              >
                <span className="daily-goal-modal__option-value">{goalValue}</span>
                <span className="daily-goal-modal__option-text">
                  {goal?.text || "Questions a day"}
                </span>
              </button>
            );
          })}
        </div>

        <p className="daily-goal-modal__best-practice">
          <strong>Best Practice:</strong> {dailyGoalData?.best_practice || ""}
        </p>

        <button
          type="button"
          className="daily-goal-modal__save-btn"
          onClick={handleSave}
          disabled={isSaving}
        >
          {isSaving ? "Saving..." : "Save Goal"}
        </button>
      </div>
    </Modal>
  );
}

export default DailyGoalModal;
